<template>
  <v-app id="app"
         class="l-body"
         :class="[classOS]"
         :style="{

         }"
  >
    <router-view name="background"></router-view>

    <modals-keep></modals-keep>

    <router-view></router-view>

    <cookie-law></cookie-law>
  </v-app>
</template>

<script>
  import './store/AppStore.js'

  import CookieLaw from '../Cookie/CookieLaw.vue'

  export default {
    name: 'app',

    components : {
      CookieLaw,
    },

    computed : {
      classOS () {
        return '__os_' + this.platformOS.toLowerCase()
      },
      platformOS () {
        let userAgent        = window.navigator.userAgent
        let platform         = window.navigator.platform
        let macosPlatforms   = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K']
        let windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE']
        let iosPlatforms     = ['iPhone', 'iPad', 'iPod']
        let os               = null

        if (macosPlatforms.indexOf(platform) !== -1) {
          os = 'MacOS'
        } else if (iosPlatforms.indexOf(platform) !== -1) {
          os = 'iOS'
        } else if (windowsPlatforms.indexOf(platform) !== -1) {
          os = 'Windows'
        } else if (/Android/.test(userAgent)) {
          os = 'Android'
        } else if (!os && /Linux/.test(platform)) {
          os = 'Linux'
        }

        return os
      },
    },

    metaInfo () {
      return {
        title : this.$store.state.Site.name,
        titleTemplate (titleChunk) {
          let siteTitle = this.$store.state.Site.name

          if (titleChunk === siteTitle) titleChunk = ''

          return titleChunk ? `${titleChunk} - ${siteTitle}` : `${siteTitle}`
        }
      }
    },

    beforeMount () {
      this.$http.get('mod/api_simple/getSiteData')
        .then(resp => resp.body)
        .then(data => {
          this.$store.commit('Site/setSiteData', data)
        })

      this.initCheckLogged = () => {
        setInterval(() => {
          this.checkLogged()
        }, 1000 * 60 * 3)
      }

      this.checkLogged = () => {
        try {
          import('src/R.js')
            .then(m => m.default)
            .then(R => {
              this.$http.post('mod/api_simple/checkLogged')
                .then(resp => {
                  let data = resp.body
                  if (data.error && data.error === 'not_logged') {
                    let requireAuth = false

                    for (let match of this.$route.matched) {
                      if (match.meta.requireAuth !== undefined) requireAuth = match.meta.requireAuth
                    }

                    if (requireAuth) {
                      this.$router.push('/forceLanding')
                    } else {
                      R.loadUserData()
                    }
                  }
                })
            })
        } catch (e) {
          console.warn(e)
        }
      }
    },

    mounted () {
      this.initCheckLogged()
    },
  }
</script>

<style lang="stylus">
  #app
    /*font-family: 'Avenir', Helvetica, Arial, sans-serif;*/
    /*-webkit-font-smoothing: antialiased;*/
    /*-moz-osx-font-smoothing: grayscale;*/
</style>

<!--Moved styles to template <head> -->
<!--<style src="bootstrap/dist/css/bootstrap.css"></style>-->
<!--<style src="font-awesome/css/font-awesome.css"></style>-->
<style src="nprogress/nprogress.css"></style>

<style lang="stylus" src="src/css/vuetify.styl"></style>
<style lang="stylus" src="src/css/global.styl"></style>
<style lang="stylus" src="src/css/bootstrap_addon.styl"></style>
<style lang="stylus" src="src/css/vue.styl"></style>
